import { SidePanelContent } from '@src/shared/ui/SidePanel';
import { useTranslation } from 'react-i18next';
import TasksFilter from './TasksFilter';
import TasksList from './TasksList';

export default function Tasks() {
  const { t } = useTranslation();

  return (
    <SidePanelContent
      title={t('common.tasks', 'Tasks')}
      headerContent={<TasksFilter />}
    >
      <TasksList />
    </SidePanelContent>
  );
}
